const Colors = {
  DisableButtonGray: "#D3D3D3",
  BlueAppColor: "#03b4ec",
  BlueGray: "#EFF6F8",
  White: "#FFFFFF",
};

exports.Colors = Colors;
